import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { DocumentsTableRow } from 'modules/customers/types';

interface Props {
  row: DocumentsTableRow;
}

export const RelatedToCell = ({ row }: Props) => {
  const relatedTo = row.taskId ? 'Task' : row.vendorOpportunityId ? 'Opportunity' : 'Customer';

  const source = row.taskRegrading ? row.taskRegrading : row.customerAccountName;

  return (
    <Box>
      <Typography variant="body2" sx={{ color: '#666666', fontWeight: 500 }}>
        {relatedTo}
      </Typography>
      {row.vendorOpportunityId ? (
        <Link target="_blank" variant="body2" href={`/vo/${row.vendorOpportunityId}`}>
          {source}
        </Link>
      ) : (
        <Typography variant="body2">{source}</Typography>
      )}
    </Box>
  );
};
